import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@LTIDashboard/App'

export function startLTIDashboard(data) {
  const root = createRoot(document.getElementById('app'))
  root.render(<App data={data} />)
}
